module.exports = __webpack_public_path__ + "img/bg-login-page.b9413c71.svg";